export default __webpack_public_path__ + "static/media/sun.5b033d7f.jpg";